import classNames from 'classnames'

import styles from './CornerBackgroundImage.module.scss'

type Props = {
  image: string
  position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
  size: number
}

const CornerBackgroundImage = ({ image, position, size }: Props) => (
  <div
    className={classNames(styles.cornerContainer, styles[position])}
    style={{
      backgroundImage: `url(${image})`,
      height: `${size}px`,
      width: `${size}px`,
    }}
  />
)

export default CornerBackgroundImage
